import React from 'react'

const Title = ({title, des}) => {
  return (
    <div className="flex flex-col gap-4 font-titleFont mb-14">
      <h3 className="text-sm uppercase font-semibold dark:text-designColor text-center text-blue-600 tracking-wide">
       {title}
      </h3>
      <h1 className="text-4xl md:text-5xl text-black dark:text-gray-300 text-center font-bold capitalize">{des}</h1>
    </div>
  );
}

export default Title